// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `pre {
  code {
    .hljs-comment {
      color: #999;
    }
    .hljs-tag {
      color: #b4b7b4;
    }
    .hljs-operator,
    .hljs-punctuation,
    .hljs-subst {
      color: #ccc;
    }
    .hljs-operator {
      opacity: 0.7;
    }
    .hljs-bullet,
    .hljs-deletion,
    .hljs-name,
    .hljs-selector-tag,
    .hljs-template-variable,
    .hljs-variable {
      color: #f2777a;
    }
    .hljs-attr,
    .hljs-link,
    .hljs-literal,
    .hljs-number,
    .hljs-symbol,
    .hljs-variable.constant_ {
      color: #f99157;
    }
    .hljs-class .hljs-title,
    .hljs-title,
    .hljs-title.class_ {
      color: #fc6;
    }
    .hljs-strong {
      font-weight: 700;
      color: #fc6;
    }
    .hljs-addition,
    .hljs-code,
    .hljs-string,
    .hljs-title.class_.inherited__ {
      color: #9c9;
    }
    .hljs-built_in,
    .hljs-doctag,
    .hljs-keyword.hljs-atrule,
    .hljs-quote,
    .hljs-regexp {
      color: #6cc;
    }
    .hljs-attribute,
    .hljs-function .hljs-title,
    .hljs-section,
    .hljs-title.function_,
    .ruby .hljs-property {
      color: #69c;
    }
    .diff .hljs-meta,
    .hljs-keyword,
    .hljs-template-tag,
    .hljs-type {
      color: #c9c;
    }
    .hljs-emphasis {
      color: #c9c;
      font-style: italic;
    }
    .hljs-meta,
    .hljs-meta .hljs-keyword,
    .hljs-meta .hljs-string {
      color: #a3685a;
    }
    .hljs-meta .hljs-keyword,
    .hljs-meta-keyword {
      font-weight: 700;
    }
  }
}

pre code {
  color: #d6deeb;
}

pre code > * {
  font-family: inherit !important;
}

/* Comments */
pre .token.comment {
  color: #999;
  font-style: italic;
}

/* Tags */
pre .token.tag {
  color: #f2777a;
}
pre .token.tag.script {
  color: #9c9;
}

pre .token.operator,
pre .token.punctuation,
pre .token.subst {
  color: #ccc;
}

pre .token.operator {
  opacity: 0.7;
}

pre .token.bullet,
pre .token.deletion,
pre .token.name,
pre .token.selector,
pre .token.template-variable,
pre .token.variable {
  color: #f2777a;
}

pre .token.attr-name,
pre .token.link,
pre .token.literal,
pre .token.number,
pre .token.symbol,
pre .token.constant {
  color: #f99157;
}

pre .token.class-name,
pre .token.title {
  color: #fc6;
  font-weight: bold;
}

pre .token.string,
pre .token.addition,
pre .token.inherited-class {
  color: #9c9;
}

pre .token.builtin,
pre .token.doctag,
pre .token.keyword,
pre .token.atrule,
pre .token.quote,
pre .token.regex {
  color: #6cc;
}

pre .token.function,
pre .token.attr-value,
pre .token.section,
pre .token.property {
  color: #69c;
}

pre .token.keyword,
pre .token.template-tag,
pre .token.type {
  color: #c9c;
}

pre .token.emphasis {
  color: #c9c;
  font-style: italic;
}

pre .token.meta,
pre .token.meta .token.keyword,
pre .token.meta .token.string {
  color: #a3685a;
}

pre .token.meta .token.keyword {
  font-weight: bold;
}

pre code {
  color: #d6deeb;
}

pre code > * {
  font-family: inherit !important;
}

/* Comments */
pre .token.comment {
  color: #999;
  font-style: italic;
}

/* Tags */
pre .token.tag {
  color: #f2777a;
}
pre .token.tag.script {
  color: #9c9;
}

pre .token.operator,
pre .token.punctuation,
pre .token.subst {
  color: #ccc;
}

pre .token.operator {
  opacity: 0.7;
}

pre .token.bullet,
pre .token.deletion,
pre .token.name,
pre .token.selector,
pre .token.template-variable,
pre .token.variable {
  color: #f2777a;
}

pre .token.attr-name,
pre .token.link,
pre .token.literal,
pre .token.number,
pre .token.symbol,
pre .token.constant {
  color: #f99157;
}

pre .token.class-name,
pre .token.title {
  color: #fc6;
  font-weight: bold;
}

pre .token.string,
pre .token.addition,
pre .token.inherited-class {
  color: #9c9;
}

pre .token.builtin,
pre .token.doctag,
pre .token.keyword,
pre .token.atrule,
pre .token.quote,
pre .token.regex {
  color: #6cc;
}

pre .token.function,
pre .token.attr-value,
pre .token.section,
pre .token.property {
  color: #69c;
}

pre .token.keyword,
pre .token.template-tag,
pre .token.type {
  color: #c9c;
}

pre .token.emphasis {
  color: #c9c;
  font-style: italic;
}

pre .token.meta,
pre .token.meta .token.keyword,
pre .token.meta .token.string {
  color: #a3685a;
}

pre .token.meta .token.keyword {
  font-weight: bold;
}

pre code {
  color: #d6deeb;
}

pre code > * {
  font-family: inherit !important;
}

/* Comments */
pre .token.comment {
  color: #999;
  font-style: italic;
}

/* Tags */
pre .token.tag {
  color: #f2777a;
}
pre .token.tag.script {
  color: #9c9;
}

pre .token.operator,
pre .token.punctuation,
pre .token.subst {
  color: #ccc;
}

pre .token.operator {
  opacity: 0.7;
}

pre .token.bullet,
pre .token.deletion,
pre .token.name,
pre .token.selector,
pre .token.template-variable,
pre .token.variable {
  color: #f2777a;
}

pre .token.attr-name,
pre .token.link,
pre .token.literal,
pre .token.number,
pre .token.symbol,
pre .token.constant {
  color: #f99157;
}

pre .token.class-name,
pre .token.title {
  color: #fc6;
  font-weight: bold;
}

pre .token.string,
pre .token.addition,
pre .token.inherited-class {
  color: #9c9;
}

pre .token.builtin,
pre .token.doctag,
pre .token.keyword,
pre .token.atrule,
pre .token.quote,
pre .token.regex {
  color: #6cc;
}

pre .token.function,
pre .token.attr-value,
pre .token.section,
pre .token.property {
  color: #69c;
}

pre .token.keyword,
pre .token.template-tag,
pre .token.type {
  color: #c9c;
}

pre .token.emphasis {
  color: #c9c;
  font-style: italic;
}

pre .token.meta,
pre .token.meta .token.keyword,
pre .token.meta .token.string {
  color: #a3685a;
}

pre .token.meta .token.keyword {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/openai-widget/components/markdown/code-highlight-block.css"],"names":[],"mappings":"AAAA;EACE;IACE;MACE,WAAW;IACb;IACA;MACE,cAAc;IAChB;IACA;;;MAGE,WAAW;IACb;IACA;MACE,YAAY;IACd;IACA;;;;;;MAME,cAAc;IAChB;IACA;;;;;;MAME,cAAc;IAChB;IACA;;;MAGE,WAAW;IACb;IACA;MACE,gBAAgB;MAChB,WAAW;IACb;IACA;;;;MAIE,WAAW;IACb;IACA;;;;;MAKE,WAAW;IACb;IACA;;;;;MAKE,WAAW;IACb;IACA;;;;MAIE,WAAW;IACb;IACA;MACE,WAAW;MACX,kBAAkB;IACpB;IACA;;;MAGE,cAAc;IAChB;IACA;;MAEE,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,aAAa;AACb;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,aAAa;AACb;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,aAAa;AACb;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["pre {\n  code {\n    .hljs-comment {\n      color: #999;\n    }\n    .hljs-tag {\n      color: #b4b7b4;\n    }\n    .hljs-operator,\n    .hljs-punctuation,\n    .hljs-subst {\n      color: #ccc;\n    }\n    .hljs-operator {\n      opacity: 0.7;\n    }\n    .hljs-bullet,\n    .hljs-deletion,\n    .hljs-name,\n    .hljs-selector-tag,\n    .hljs-template-variable,\n    .hljs-variable {\n      color: #f2777a;\n    }\n    .hljs-attr,\n    .hljs-link,\n    .hljs-literal,\n    .hljs-number,\n    .hljs-symbol,\n    .hljs-variable.constant_ {\n      color: #f99157;\n    }\n    .hljs-class .hljs-title,\n    .hljs-title,\n    .hljs-title.class_ {\n      color: #fc6;\n    }\n    .hljs-strong {\n      font-weight: 700;\n      color: #fc6;\n    }\n    .hljs-addition,\n    .hljs-code,\n    .hljs-string,\n    .hljs-title.class_.inherited__ {\n      color: #9c9;\n    }\n    .hljs-built_in,\n    .hljs-doctag,\n    .hljs-keyword.hljs-atrule,\n    .hljs-quote,\n    .hljs-regexp {\n      color: #6cc;\n    }\n    .hljs-attribute,\n    .hljs-function .hljs-title,\n    .hljs-section,\n    .hljs-title.function_,\n    .ruby .hljs-property {\n      color: #69c;\n    }\n    .diff .hljs-meta,\n    .hljs-keyword,\n    .hljs-template-tag,\n    .hljs-type {\n      color: #c9c;\n    }\n    .hljs-emphasis {\n      color: #c9c;\n      font-style: italic;\n    }\n    .hljs-meta,\n    .hljs-meta .hljs-keyword,\n    .hljs-meta .hljs-string {\n      color: #a3685a;\n    }\n    .hljs-meta .hljs-keyword,\n    .hljs-meta-keyword {\n      font-weight: 700;\n    }\n  }\n}\n\npre code {\n  color: #d6deeb;\n}\n\npre code > * {\n  font-family: inherit !important;\n}\n\n/* Comments */\npre .token.comment {\n  color: #999;\n  font-style: italic;\n}\n\n/* Tags */\npre .token.tag {\n  color: #f2777a;\n}\npre .token.tag.script {\n  color: #9c9;\n}\n\npre .token.operator,\npre .token.punctuation,\npre .token.subst {\n  color: #ccc;\n}\n\npre .token.operator {\n  opacity: 0.7;\n}\n\npre .token.bullet,\npre .token.deletion,\npre .token.name,\npre .token.selector,\npre .token.template-variable,\npre .token.variable {\n  color: #f2777a;\n}\n\npre .token.attr-name,\npre .token.link,\npre .token.literal,\npre .token.number,\npre .token.symbol,\npre .token.constant {\n  color: #f99157;\n}\n\npre .token.class-name,\npre .token.title {\n  color: #fc6;\n  font-weight: bold;\n}\n\npre .token.string,\npre .token.addition,\npre .token.inherited-class {\n  color: #9c9;\n}\n\npre .token.builtin,\npre .token.doctag,\npre .token.keyword,\npre .token.atrule,\npre .token.quote,\npre .token.regex {\n  color: #6cc;\n}\n\npre .token.function,\npre .token.attr-value,\npre .token.section,\npre .token.property {\n  color: #69c;\n}\n\npre .token.keyword,\npre .token.template-tag,\npre .token.type {\n  color: #c9c;\n}\n\npre .token.emphasis {\n  color: #c9c;\n  font-style: italic;\n}\n\npre .token.meta,\npre .token.meta .token.keyword,\npre .token.meta .token.string {\n  color: #a3685a;\n}\n\npre .token.meta .token.keyword {\n  font-weight: bold;\n}\n\npre code {\n  color: #d6deeb;\n}\n\npre code > * {\n  font-family: inherit !important;\n}\n\n/* Comments */\npre .token.comment {\n  color: #999;\n  font-style: italic;\n}\n\n/* Tags */\npre .token.tag {\n  color: #f2777a;\n}\npre .token.tag.script {\n  color: #9c9;\n}\n\npre .token.operator,\npre .token.punctuation,\npre .token.subst {\n  color: #ccc;\n}\n\npre .token.operator {\n  opacity: 0.7;\n}\n\npre .token.bullet,\npre .token.deletion,\npre .token.name,\npre .token.selector,\npre .token.template-variable,\npre .token.variable {\n  color: #f2777a;\n}\n\npre .token.attr-name,\npre .token.link,\npre .token.literal,\npre .token.number,\npre .token.symbol,\npre .token.constant {\n  color: #f99157;\n}\n\npre .token.class-name,\npre .token.title {\n  color: #fc6;\n  font-weight: bold;\n}\n\npre .token.string,\npre .token.addition,\npre .token.inherited-class {\n  color: #9c9;\n}\n\npre .token.builtin,\npre .token.doctag,\npre .token.keyword,\npre .token.atrule,\npre .token.quote,\npre .token.regex {\n  color: #6cc;\n}\n\npre .token.function,\npre .token.attr-value,\npre .token.section,\npre .token.property {\n  color: #69c;\n}\n\npre .token.keyword,\npre .token.template-tag,\npre .token.type {\n  color: #c9c;\n}\n\npre .token.emphasis {\n  color: #c9c;\n  font-style: italic;\n}\n\npre .token.meta,\npre .token.meta .token.keyword,\npre .token.meta .token.string {\n  color: #a3685a;\n}\n\npre .token.meta .token.keyword {\n  font-weight: bold;\n}\n\npre code {\n  color: #d6deeb;\n}\n\npre code > * {\n  font-family: inherit !important;\n}\n\n/* Comments */\npre .token.comment {\n  color: #999;\n  font-style: italic;\n}\n\n/* Tags */\npre .token.tag {\n  color: #f2777a;\n}\npre .token.tag.script {\n  color: #9c9;\n}\n\npre .token.operator,\npre .token.punctuation,\npre .token.subst {\n  color: #ccc;\n}\n\npre .token.operator {\n  opacity: 0.7;\n}\n\npre .token.bullet,\npre .token.deletion,\npre .token.name,\npre .token.selector,\npre .token.template-variable,\npre .token.variable {\n  color: #f2777a;\n}\n\npre .token.attr-name,\npre .token.link,\npre .token.literal,\npre .token.number,\npre .token.symbol,\npre .token.constant {\n  color: #f99157;\n}\n\npre .token.class-name,\npre .token.title {\n  color: #fc6;\n  font-weight: bold;\n}\n\npre .token.string,\npre .token.addition,\npre .token.inherited-class {\n  color: #9c9;\n}\n\npre .token.builtin,\npre .token.doctag,\npre .token.keyword,\npre .token.atrule,\npre .token.quote,\npre .token.regex {\n  color: #6cc;\n}\n\npre .token.function,\npre .token.attr-value,\npre .token.section,\npre .token.property {\n  color: #69c;\n}\n\npre .token.keyword,\npre .token.template-tag,\npre .token.type {\n  color: #c9c;\n}\n\npre .token.emphasis {\n  color: #c9c;\n  font-style: italic;\n}\n\npre .token.meta,\npre .token.meta .token.keyword,\npre .token.meta .token.string {\n  color: #a3685a;\n}\n\npre .token.meta .token.keyword {\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
